module.exports = __webpack_public_path__ + "static/media/louis-hansel-dNgwsE2HRJw-unsplash.216981c5.jpg";